import type { CSSProperties, ReactElement } from 'react';

import { styled } from 'styled-components';

const FigureSC = styled.figure`
  margin: 0;
  display: flex;
  flex-direction: column;
`;

const FigCaptionSC = styled.figcaption<{ $textAlign?: CSSProperties['textAlign'] }>`
  color: ${(props) => props.theme.colors.oxfordBlue[50]};
  font-size: ${(props) => props.theme.fontSizes.s};
  letter-spacing: -0.02em;
  margin-top: 0.5rem;
  text-align: ${(props) => (props.$textAlign ? props.$textAlign : 'inherit')};
`;

export type Props = {
  children: ReactElement;
  className?: string;
  'data-test-id'?: string;
  label: string;
  labelPosition?: CSSProperties['textAlign'];
};

export const Figure = ({ children, className, 'data-test-id': dataTestId, label, labelPosition }: Props) => {
  return (
    <FigureSC className={className} data-test-id={dataTestId}>
      {children}
      <FigCaptionSC $textAlign={labelPosition}>{label}</FigCaptionSC>
    </FigureSC>
  );
};
